import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { UIComponentHandler, UIDataModel } from "../../../../toolkit/uicomponent";
import { UIComponentCSSStyle } from "../../../../toolkit/uicomponentcss";
import { UIComponentView } from "../../../../toolkit/uicomponentview";
import { InfoComponent, InfoComponentProps } from "../infocomponent";
import { InfoCSSStyleImpl } from "../infocss";
import { DeleteInfoViewImpl } from "./deleteinfoview";

export interface DeleteInfoComponentProps extends InfoComponentProps
{

}
export class DeleteInfoComponent extends InfoComponent
{
    constructor(props: DeleteInfoComponentProps)
    {
        super(props);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new DeleteInfoViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new InfoCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/info/deleteinfo/deleteinfocomponent.tsx